import makeSlice from '@web/slices/deliveryInfo/sliceMaker'

const slice = makeSlice()

export default slice.reducer
